import {
  SET_PROGRESS_BAR_VISIBLE,
  SET_PROGRESS_BAR_TOTAL,
  SET_PROGRESS_BAR_PROGRESS,
  SET_PROGRESS_BAR_MESSAGE,
  RESET_PROGRESS_BAR
} from 'shared/actions/types';

export const setProgressBarVisible = visible => dispatch => {
  dispatch({
    type: SET_PROGRESS_BAR_VISIBLE,
    payload: visible
  });
}

export const setProgressBarTotal = total => dispatch => {
  dispatch({
    type: SET_PROGRESS_BAR_TOTAL,
    payload: total
  });
}

export const setProgressBarProgress = progress => dispatch => {
  dispatch({
    type: SET_PROGRESS_BAR_PROGRESS,
    payload: progress
  });
}

export const setProgressBarMessage = message => dispatch => {
  dispatch({
    type: SET_PROGRESS_BAR_MESSAGE,
    payload: message
  });
}

export const resetProgressBar = () => dispatch => {
  dispatch({
    type: RESET_PROGRESS_BAR
  });
}
